module.exports = __webpack_public_path__ + "static/media/planning2@2x.8676ccd6.png";